document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('[data-pz-hero-carousel]');
  if (!carousel) return;

  const track = carousel.querySelector('.pz-hero-track');
  const realSlides = [...carousel.querySelectorAll('.pz-hero-slide:not(.is-clone)')];
  const dots = [...carousel.querySelectorAll('.pz-hero-dots button')];
  const prev = carousel.querySelector('.pz-hero-arrow--prev');
  const next = carousel.querySelector('.pz-hero-arrow--next');

  if (!track || realSlides.length < 2) return;

  const firstClone = realSlides[0].cloneNode(true);
  const lastClone = realSlides[realSlides.length - 1].cloneNode(true);

  firstClone.classList.add('is-clone');
  lastClone.classList.add('is-clone');

  track.insertBefore(lastClone, realSlides[0]);
  track.appendChild(firstClone);

  const slides = [...track.querySelectorAll('.pz-hero-slide')];

  let current = 1;
  let timer = null;
  let isAnimating = false;

  const interval = 4500;
  const duration = 600;

  function setPosition(animate = true) {
    track.style.transition = animate
      ? `transform ${duration}ms cubic-bezier(.22,.61,.36,1)`
      : 'none';

    track.style.transform = `translateX(${-current * 100}%)`;
  }

  function normalizePosition() {
    if (current === 0) current = realSlides.length;
    if (current === realSlides.length + 1) current = 1;

    setPosition(false);
    updateDots();
    isAnimating = false;
  }

  function updateDots() {
    const realIndex = (current - 1 + realSlides.length) % realSlides.length;

    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === realIndex);
    });
  }

  function goTo(index) {
    if (isAnimating) return;

    isAnimating = true;
    current = index;

    setPosition(true);
    updateDots();

    window.setTimeout(() => {
      normalizePosition();
    }, duration + 40);
  }

  function nextSlide() {
    goTo(current + 1);
  }

  function prevSlide() {
    goTo(current - 1);
  }

  function startTimer() {
    stopTimer();

    if (document.hidden) return;

    timer = window.setInterval(() => {
      if (!document.hidden) nextSlide();
    }, interval);
  }

  function stopTimer() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  next?.addEventListener('click', () => {
    normalizePosition();
    nextSlide();
    startTimer();
  });

  prev?.addEventListener('click', () => {
    normalizePosition();
    prevSlide();
    startTimer();
  });

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      normalizePosition();
      goTo(index + 1);
      startTimer();
    });
  });

  carousel.addEventListener('mouseenter', stopTimer);
  carousel.addEventListener('mouseleave', startTimer);

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopTimer();
    } else {
      normalizePosition();
      startTimer();
    }
  });

  setPosition(false);
  updateDots();
  startTimer();
});